import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ADMIN_ACCESS_USERS = createActionTypes('FETCH_ADMIN_ACCESS_USERS');
export const CREATE_ADMIN_ACCESS = createActionTypes('CREATE_ADMIN_ACCESS');
